import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CoronavirusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"coronavirus"}/>
}
